export const Bio = {
  name: "Karn Bhavsar",
  roles: [
    "Full Stack Web Developer",
    "Game Developer",
    "VR Application Developer",
  ],
  description:
    "I’m a passionate Front-End Web and Game Developer with a strong focus on creating engaging, scalable web interfaces and immersive interactive experiences. With a background in Software Engineering and expertise in technologies like React, Next.js, Tailwind CSS, and Unity/Unreal Engine, I specialize in building user-centric applications that merge performance with visual appeal. While I have full-stack experience, my strengths and interests lie in front-end development—especially where design, interactivity, and storytelling come together through code.",
  github: "https://github.com/KARNB24",
  linkedin: "https://www.linkedin.com/in/karn-bhavsar/",
  email: "mailto:karnbhavsar12@gmail.com",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React.js",
        image: "https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg",
      },
      {
        name: "Next.js",
        image: "https://cdn.worldvectorlogo.com/logos/next-js.svg",
      },
      {
        name: "TypeScript",
        image: "https://cdn.worldvectorlogo.com/logos/typescript.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg",
      },
      {
        name: "HTML5",
        image: "https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg",
      },
      {
        name: "CSS3",
        image: "https://www.vectorlogo.zone/logos/w3_css/w3_css-icon.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg",
      },
      { name: "Material UI", image: "https://mui.com/static/logo.png" },
    ],
  },
  {
    title: "State & APIs",
    skills: [
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/reduxjs/redux/master/logo/logo.png",
      },
      {
        name: "REST APIs",
        image: "https://www.vectorlogo.zone/logos/json/json-icon.svg",
      },
      {
        name: "Responsive Design",
        image: "https://cdn-icons-png.flaticon.com/512/1006/1006771.png",
      },
      {
        name: "SEO Optimization",
        image: "https://cdn-icons-png.flaticon.com/512/2819/2819194.png",
      },
    ],
  },
  {
    title: "Testing & DevOps",
    skills: [
      {
        name: "Jest",
        image: "https://www.vectorlogo.zone/logos/jestjsio/jestjsio-icon.svg",
      },
      {
        name: "Playwright",
        image: "https://playwright.dev/img/playwright-logo.svg",
      },
      {
        name: "React Testing Library",
        image: "https://testing-library.com/img/octopus-128x128.png",
      },
      {
        name: "GitHub Actions",
        image: "https://cdn.worldvectorlogo.com/logos/github-icon-1.svg",
      },
      {
        name: "Manual Testing",
        image: "https://cdn-icons-png.flaticon.com/512/2620/2620611.png",
      },
    ],
  },
  {
    title: "Tools & Workflow",
    skills: [
      {
        name: "Git",
        image: "https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg",
      },
      {
        name: "GitHub",
        image: "https://cdn.worldvectorlogo.com/logos/github-icon-2.svg",
      },
      {
        name: "Figma",
        image: "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
      {
        name: "Jira",
        image:
          "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
      {
        name: "Confluence",
        image: "https://cdn.worldvectorlogo.com/logos/confluence-1.svg",
      },
      {
        name: "Vercel",
        image: "https://www.vectorlogo.zone/logos/vercel/vercel-icon.svg",
      },
      {
        name: "Netlify",
        image: "https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg",
      },
      {
        name: "GCP",
        image: "https://cdn.worldvectorlogo.com/logos/google-cloud-1.svg",
      },
    ],
  },
  {
    title: "Other Experience",
    skills: [
      {
        name: "Node.js",
        image: "https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg",
      },
      {
        name: "Express.js",
        image: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg",
      },
      {
        name: "MongoDB",
        image: "https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg",
      },
      {
        name: "Stripe",
        image: "https://www.vectorlogo.zone/logos/stripe/stripe-icon.svg",
      },
      {
        name: "Clerk",
        image:
          "https://raw.githubusercontent.com/simple-icons/simple-icons/f06f3d2b98d0976820b6b7a8a1778858a7f554f6/icons/clerk.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Unity (C#)",
        image: "https://www.vectorlogo.zone/logos/unity3d/unity3d-icon.svg",
      },
      {
        name: "Agile/Scrum",
        image: "https://cdn-icons-png.flaticon.com/512/2721/2721320.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/v2/C4E0BAQEbR28psh7rrg/company-logo_200_200/company-logo_200_200/0/1668114936874?e=1756944000&v=beta&t=4NypncSvEYC1PEVmrdNHbzGcaDHamcA252-b9eSBC5Y",
    role: "Frontend Developer & AR/XR QA Engineer",
    company: "Phygtl, Inc.",
    date: "June 2024 - Present",
    desc: [
      "Led development of a new invite flow website using HTML, CSS, JavaScript, Tailwind CSS, Golang, and GCP, streamlining user onboarding and improving efficiency by 25%.",
      "Collaborated with PMs, designers, and AR/AI developers to deliver high-performance, responsive UIs across web and mobile platforms.",
      "Implemented rigorous cross-platform testing in Android, iOS, and Unity Editor, ensuring consistent performance and reducing production bugs by 20%.",
      "Used Jira and agile best practices to manage sprints, bug tracking, and QA cycles.",
    ],

    skills: ["Unity", "C#", "GenAI", "Android", "IOS", "AR", "GCP", "Jira"],
  },
  {
    id: 1,
    img: "https://media.licdn.com/dms/image/v2/D4E0BAQG3hy1Xd6pwzg/company-logo_200_200/company-logo_200_200/0/1712709844988?e=1756944000&v=beta&t=9tiUbPRhpncWciMI35GKFgnycc9KqfJaXfXp_Q7ftR4",
    role: "Backend Developer",
    company: "Zeuty",
    date: "June 2024 - Present",
    desc: [
      "Utilize Node.js, Express, and TypeORM to create robust, scalable, and efficient RESTful APIs and microservices, ensuring seamless integration with PostgreSQL databases, leading to a 30% increase in accessibility.",
      "Work closely with backend Lead and front-end Developers to ensure high-quality code, implement best practices, participate in code reviews, and agile development processes, contributing to a 20% reduction in development time.",
      "Design, implement, and optimize PostgreSQL database schemas, queries, and stored procedures to enhance application performance, reliability, and data integrity, resulting in a 25% improvement in query execution times.",
    ],
    skills: ["Node.js", "Express.js", "TypeORM", "PostgreSQL"],
  },
  {
    id: 2,
    img: "https://asset.brandfetch.io/idR41WzV2a/idbG-5v0ZP.jpeg?updated=1701588458535",
    role: "VR Application Developer",
    company: "Sheridan CMI",
    date: "May 2022 - March 2023",
    desc: [
      "Led end-to-end development of two medical VR apps for PC, VR, and WebGL, improving accessibility by 30%.",
      "Conducted client demos and feedback sessions, increasing satisfaction by 20% and reducing delays by 15%.",
      "Used Jira to streamline workflows, increasing team productivity by 25%.",
      "Implemented Git/GitHub CI/CD pipelines, reducing development cycles by 30%.",
    ],
    skills: [
      "C#",
      "Unity Oculus Build",
      "Unity PC Build",
      "Unity WebGL Build",
      "OpenXR",
    ],
  },
  {
    id: 3,
    img: "https://static.wixstatic.com/media/6357fd_54f46f182a4c4228a0628cea3cd68c2b~mv2.png/v1/crop/x_14,y_0,w_738,h_329/fill/w_229,h_102,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/6357fd_54f46f182a4c4228a0628cea3cd68c2b~mv2.png",
    role: "Application Developer",
    company: "Canadian Hospital Specialties Ltd.",
    date: "January 2021 - December 2021",
    desc: [
      "Developed an Inventory Management System for iOS/Android platforms using Microsoft Power Apps, increasing inventory tracking accuracy by 40%.",
      "Leveraged the Quality Management System (QMS) to ensure compliance with quality standards, reducing operational errors by 20% and improving process efficiency by 15%.",
      "Utilized SQL queries in the AssurX development environment to sort and manipulate datasets, executing over 500 queries.",
      "Improved data retrieval speed by 30%, reduced processing time by 25%, and enhanced overall database efficiency by 20%.",
    ],
    skills: [
      "Microsoft Power Apps",
      "Microsoft Power Automate",
      "SharePoint",
      "Jira",
      "AssurX",
      "MySQL",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://asset.brandfetch.io/idR41WzV2a/idbG-5v0ZP.jpeg?updated=1701588458535",
    school: "Sheridan College",
    date: "Sept 2019 - Dec 2022",
    grade: "3.69 CGPA",
    desc: "Courses: Web Development, Advance Web Development, Interactive User Design, Software Design Fundamentals, 3D Game Programming, Advance 3D Game Programming",
    degree: "Advanced Diploma in Software Development and Network Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwCRG2lkGcvsO56DZyjyAs0pTCT3cn178Qvd0CYFhVqQ&s",
    school: "Ontario Tech University",
    date: "Sept 2014 - Dec 2018",
    grade: "3.0 CGPA",
    desc: "Courses: Web Programming, Object Oriented Programming, User Interface, Cloud Computing, Mobile App Development",
    degree: "Bachelor of Engineering in Software Engineering",
  },
];

export const projects = [
  {
    id: 0,
    title: "KarnaVision - DALL-E Clone",
    description:
      "KarnaVision is an DALL-E clone which uses OpenAI api to generate AI images based on text input",
    notes_1: "Notes:",
    notes_2:
      "If you see a loading indicator when on home page, simply refresh the page. This happens because the backend service I used is Render and they sometimes go to sleep when not active",
    notes_3: "More details in GitHub Repository",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/KarnaVision.png",
    tags: [
      "React",
      "Mern Stack",
      "OpenAI",
      "TailwindCSS",
      "Render",
      "Cloudinary",
    ],
    category: "web app",
    github: "https://github.com/KARNB24/KarnaVision_Dalle_Clone",
    webapp: "https://karnavision.netlify.app/",
  },
  {
    id: 1,
    title: "PolySphere - Interactive 3D Geometry using Three JS",
    description:
      "PolySphere is my first project using Three.js. It features an interactive, low-poly icosahedron with a wireframe overlay and responsive camera controls.",
    notes_1: "Notes:",
    notes_2:
      "You can rotate and zoom in/out using your mouse. The canvas is responsive and takes up the full screen.",
    notes_3: "More details in GitHub Repository",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/PolySphere.png",
    tags: ["Three.js", "WebGL", "JavaScript", "OrbitControls", "Geometry"],
    category: "web app",
    github: "https://github.com/KARNB24/PolySphere",
    webapp: "https://poly-sphere.netlify.app/",
  },
  {
    id: 2,
    title: "Earth - Realistic 3D Planet in Three.js",
    description:
      "Earth is my second Three.js project that visualizes a realistic 3D rotating Earth with city lights, bump mapping, clouds, atmosphere glow, and a starfield.",
    notes_1: "Notes:",
    notes_2:
      "All Earth elements are grouped and tilted by 23.4° for realism. The glow is created using a Fresnel shader material.",
    notes_3:
      "Clouds, lights, and Earth all rotate independently for dynamic realism.",
    notes_4: "More details in GitHub Repository",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/EarthProject.png",
    tags: [
      "Three.js",
      "WebGL",
      "JavaScript",
      "Shaders",
      "Textures",
      "OrbitControls",
    ],
    category: "web app",
    github: "https://github.com/KARNB24/Earth",
    webapp: "https://earth01.netlify.app/",
  },
  {
    id: 3,
    title: "Fitpro Gym",
    description:
      "Welcome to Fitpro Gym! This React app is designed to help you explore a wide range of exercises, focusing on different categories and muscle groups. With practical examples, detailed exercise descriptions, related videos from YouTube, and more, Fitpro Gym is your ultimate fitness companion.",
    notes_1: "",
    notes_2: "",
    notes_3: "",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/FitproGym.png",
    tags: ["React", "MaterialUI", "RapidAPI"],
    category: "web app",
    github: "https://github.com/KARNB24/fitnessapp_fitprogym.git",
    webapp: "https://fitprogym.netlify.app/",
  },
  {
    id: 4,
    title: "GatherVibe",
    description:
      "GatherVibe is a Meetup or Eventbrite-like event organization web app created using Next.js 14. It is a full-stack application built to streamline event management and attendance tracking.",
    notes_1: "Notes:",
    notes_2:
      "Auth: Use Google or Github login/signup only (Explained in Github repository README)",
    notes_3: "More Details on Github repository ",

    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/GatherVibe.png",
    tags: [
      "React",
      "Next.js 14",
      "TailwindCSS",
      "Node.js",
      "Clerk",
      "Stripe",
      "Zod",
      "Uploadthing",
    ],
    category: "web app",
    github: "https://github.com/KARNB24/gathervibe.git",
    webapp: "https://gathervibe.vercel.app/",
  },
  {
    id: 5,
    title: "Storm Runner 3D - Unity Game (WebGL)",
    description:
      "This is a 3D Storm Runner game created using Unity and C#. The game utilizes various Unity features such as the Unity Character Controller, Unity Player Animation Controller, Unity Rigidbody (Physics), and more.",
    notes_1: "",
    notes_2: "",
    notes_3: "",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/StormRunner3D.png",
    tags: ["Unity", "C#", "WebGL"],
    category: "unity",
    github: "https://github.com/KARNB24/StormRunner3D",
    webapp: "https://stormrunner3d.netlify.app/",
  },
  {
    id: 6,
    title: "Space Shooter 2D - Unity Game (WebGL)",
    description:
      "Created an 2D Space Shooter Game using Unity and C# (Play in Web Browser as this a WebGl Build)",
    notes_1: "",
    notes_2: "",
    notes_3: "",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/SpaceShooter2DWebGL.png",
    tags: ["Unity", "C#", "WebGL"],
    category: "unity",
    github: "https://github.com/KARNB24/SpaceShooter2D",
    webapp: "https://karn-spaceshooter2d.netlify.app/",
  },
  {
    id: 7,
    title: "Space Shooter 2D - Unity Game (Android)",
    description:
      "Created an 2D Space Shooter Game using Unity and C# (Android)",
    notes_1: "",
    notes_2: "",
    notes_3: "",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/ProjectImages/SpaceShooter3DAndroid.png",
    tags: ["Unity", "C#", "Android"],
    category: "android app",
    github: "https://github.com/KARNB24/SpaceShooter2D",
    webapp:
      "https://drive.google.com/file/d/1K1ysjwc1ZbJDI48yEtj4NKkRZ9WF1mFl/view?usp=sharing",
  },
  {
    id: 8,
    title: "Warehouse Wreckage (Unreal Engine 5)",
    description:
      "Welcome to Warehouse Wreckage, a basic game developed in Unreal Engine 5 where you can unleash destruction upon a warehouse using projectiles!",
    notes_1: "Click on View Live App to view demo of the game",
    notes_2: "Windows version is not available for download via View Live App",
    notes_3:
      "Download the project from github and test it out in Unreal Engine 5",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/WarehouseWreckage/assets/59581104/35dd4ada-8ea4-4ddb-9776-73b305b3033f",
    tags: ["Unreal Engine 5", "Blueprints", "Windows"],
    category: "unreal",
    github: "https://github.com/KARNB24/WarehouseWreckage",
    webapp:
      "https://drive.google.com/file/d/1AWt9nQRwhlt0yRY_QD4kBcdMn3IZDPKb/view?usp=sharing",
  },
  {
    id: 9,
    title: "Obstacle Assault (Unreal Engine 5)",
    description:
      "Welcome to Obstacle Assault, a thrilling game developed in Unreal Engine 5 where your objective is to navigate through challenging obstacles to reach the finish line!",
    notes_1: "Click on View Live App to view demo of the game",
    notes_2: "Windows version is not available for download via View Live App",
    notes_3:
      "Download the project from github and test it out in Unreal Engine 5",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/ObstacleAssault/assets/59581104/fbc04e3b-b0ae-45b4-843a-eea145ccbc5f",
    tags: ["Unreal Engine 5", "Blueprints", "C++"],
    category: "unreal",
    github: "https://github.com/KARNB24/ObstacleAssault.git",
    webapp:
      "https://drive.google.com/file/d/1yC2_R8sjowRRU2yL4IJAIQ_4c10PhwTp/view?usp=sharing",
  },
  {
    id: 10,
    title: "Crypt Raider (Unreal Engine 5)",
    description:
      "Crypt Raider is a puzzle game created in Unreal Engine 5.3.2 that immerses players in a dungeon atmosphere. In Crypt Raider, players experience a third-person perspective, immersing themselves in the game world. They can interact with objects using the left mouse button to solve puzzles and advance through the environment. Additionally, players can engage with pressure plates to activate environmental changes, such as opening doors and unlocking new areas, adding depth to the gameplay experience.",
    notes_1: "Click on View Live App to view demo of the game",
    notes_2: "Windows version is not available for download via View Live App",
    notes_3:
      "Download the project from github and test it out in Unreal Engine 5",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/CryptRaider/assets/59581104/daf22146-6329-4e3b-a791-60933b362ade",
    tags: [
      "Unreal Engine 5",
      "Blueprints",
      "C++",
      "Lumen Lighting",
      "Collisions",
      "Triggers",
      "Line Tracing",
      "Pressure Plate",
    ],
    category: "unreal",
    github: "https://github.com/KARNB24/CryptRaider.git",
    webapp:
      "https://drive.google.com/file/d/17t1k29sSpwMBomGabm8hsFCi6_pa9hqn/view?usp=sharing",
  },
  {
    id: 11,
    title: "Toon Tanks (Unreal Engine 5)",
    description:
      "Welcome to Toon Tanks! This is a game created in Unreal Engine 5.3.2 where you control a tank turret and your objective is to destroy all enemy tank turrets. Be cautious, if your tank gets destroyed, you lose the game.",
    notes_1: "Click on View Live App to view demo of the game",
    notes_2: "Windows version is not available for download via View Live App",
    notes_3:
      "Download the project from github and test it out in Unreal Engine 5",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/ToonTanks/assets/59581104/d2b54448-93d3-47d0-a66a-5bafd87e946d",
    tags: [
      "Unreal Engine 5",
      "Blueprint",
      "C++",
      "Input Handling",
      "Health System",
      "Damage System",
      "SFX",
      "Win/Lose Widgets",
      "Projectile Firing",
    ],
    category: "unreal",
    github: "https://github.com/KARNB24/ToonTanks.git",
    webapp:
      "https://drive.google.com/file/d/1l34NzcV3D9wtnjx44Y1uJK_W6LFZJlfc/view?usp=sharing",
  },
  {
    id: 12,
    title: "Astral Warfare: Quantum Reckoning (Unreal Engine 5)",
    description:
      "Welcome to Astral Warfare: Quantum Reckoning, an action-packed game developed on Unreal Engine 5.3.2. In this thrilling adventure, your mission is to infiltrate and acquire the enemy headquarters by eliminating all adversaries in the level. Beware, failure to do so will result in losing the game!",
    notes_1: "Click on View Live App to view demo of the game",
    notes_2: "Windows version is not available for download via View Live App",
    notes_3:
      "Download the project from github and test it out in Unreal Engine 5",
    notes_4: "",
    notes_5: "",
    notes_6: "",
    image:
      "https://github.com/KARNB24/Astral-Warfare/assets/59581104/1764b313-ce91-4770-9089-ff71f8757eee",
    tags: [
      "Unreal Engine 5",
      "Blueprint",
      "C++",
      "Player Movement",
      "Player Animation",
      "Health System",
      "Death System",
      "SFX",
      "Shooting Architecture",
      "Gun Architecture",
      "Enemy AI",
      "Behaviour Tree",
    ],
    category: "unreal",
    github: "https://github.com/KARNB24/Astral-Warfare.git",
    webapp:
      "https://drive.google.com/file/d/13XcMszRocwUIZEMxvRoDY0E_NTUrcwbW/view?usp=sharing",
  },
];

export const certificate = [
  {
    id: 0,
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/Certificates/OrcleCertificate.png",
    link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=E89FFC60345757B5F3965200DCE053C1061EC2CBB80907C28A0F877E1A72BF86",
  },
  {
    id: 1,
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/Certificates/WebDevelopmenCertificate.jpg",
    link: "https://www.udemy.com/certificate/UC-JIQ4E8AD/",
  },
  {
    id: 2,
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/Certificates/Unity%20Certificate.jpg",
    link: "https://www.udemy.com/certificate/UC-467fa059-682a-4d28-802c-b1cc9ce68f9e/",
  },
  {
    id: 3,
    image:
      "https://github.com/KARNB24/PortfolioImages/raw/main/Certificates/IBM%20Full%20Stack%20Software%20Developer%20Certificate.jpg",
    link: "https://www.coursera.org/account/accomplishments/professional-cert/KXRCRBARGS5E",
  },
  {
    id: 4,
    image:
      "https://udemy-certificate.s3.amazonaws.com/image/UC-d6ec13ce-f68c-4c7c-84cd-c1b0fa69854a.jpg",
    link: "https://www.udemy.com/certificate/UC-d6ec13ce-f68c-4c7c-84cd-c1b0fa69854a/",
  },
];
